import * as React from "react";

const LiveSetUploadProgress = () => (
  <div id="liveset-upload-dropzone">
    <img src="/loading.gif" alt="Loading" />
  </div>
);

export default LiveSetUploadProgress;
